import React from "react";
import {
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useParams, useNavigate } from "react-router-dom";
import BackgroundImage from "../assests/home-banner.webp";

const PopupPage = () => {
  const divStyle = {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover", // Ensures the image covers the entire div
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat", // Prevents the image from repeating
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%", // Makes the div take the full width of its container
    height: "100vh", // Makes the div take the full height of the viewport
    padding: "20px", // Adding padding to the outer div if needed
  };

  const navigate = useNavigate();
  const { coupon } = useParams();

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Grid container spacing={2} className="content1" style={divStyle}>
      <Dialog
        open={true}
        onClose={() => {
          handleClose();
        }}
      >
        <DialogTitle>
          Your Exclusive Reward!
          <IconButton
            aria-label="close"
            onClick={() => {
              handleClose();
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom align="center">
            Welcome to our world of modern ​contemporary furniture! Transform
            your ​home with our stylish and functional ​pieces. From stylish
            sofas to elegant ​dining sets, we’ve got you covered.
          </Typography>

          <Typography align="center" sx={{ mt: 2 }}>
            And here’s the cherry on top: Use code <strong>{coupon}</strong> at
            checkout to unlock ​exclusive savings! 🎉
          </Typography>
          <Typography align="center" sx={{ mt: 2 }}>
            We have also sent the discount to your ​email!
          </Typography>

          <Typography align="center" sx={{ mt: 2 }}>
            Your space deserves the best—shop now ​and elevate your living
            experience! ✨
          </Typography>
          <Typography style={{ textAlign: "center", fontWeight: 600 }}>
            Happy shopping!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              window.location.href = "https://www.kaluinteriors.com.au/";
            }}
          >
            Shop Now
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PopupPage;
